import ZillowInsuranceServicesLogo from '../../ZillowInsuranceServicesLogo';
import { Modal } from '@zillow/constellation-10';

import RentalProtectionHowDoesItWorkModalBody from './RentalProtectionHowDoesItWorkModalBody';

type RentalProtectionHowDoesItWorkModalProps = {
  onClose?: () => void;
  onDropRentalProtectionClick?: (() => void) | null;
  footer: React.ReactNode;
  isLowFrictionEnabled?: boolean;
  closeOnOutsidePress?: boolean;
  hideCloseButton?: boolean;
};

const RentalProtectionHowDoesItWorkModal = ({
  onClose = () => {},
  onDropRentalProtectionClick = null,
  footer,
  isLowFrictionEnabled = false,
  closeOnOutsidePress = true,
  hideCloseButton = false,
}: RentalProtectionHowDoesItWorkModalProps) => {
  return (
    <div data-testid="RentalProtectionHowDoesItWorkModal">
      <Modal
        open={true}
        onOpenChange={(open) => !open && onClose()}
        header={<ZillowInsuranceServicesLogo />}
        body={
          <RentalProtectionHowDoesItWorkModalBody
            onDropRentalProtectionClick={onDropRentalProtectionClick}
            isLowFrictionEnabled={isLowFrictionEnabled}
          />
        }
        footer={footer && footer}
        size={{ base: 'fullScreen', xl: 'md' }}
        closeButton={hideCloseButton ? null : <Modal.CloseButton />}
        useDismissProps={{ outsidePress: closeOnOutsidePress }}
      />
    </div>
  );
};

export default RentalProtectionHowDoesItWorkModal;
